module.exports = __webpack_public_path__ + "static/L5Y5-809d59e3bba8b10576f33ba4916f0436.jpg";